<template lang="html">
  <div class="register-form">
    <h1>Sign Up</h1>

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"
    />

    <form @submit.prevent="submit">
       <Field
        label="Full Name"
        :placeholder="namePlaceholder"
        @input="$v.resource.name.$touch()"
        v-model="resource.name"
        :error="nameError"
      />

      <Field
        label="Business Name"
        helpText="You can change this later"
        placeholder="My Building Company ltd"
        @input="$v.resource.companyName.$touch()"
        v-model="resource.companyName"
        :error="companyNameError"
      />

      <Field
        label="Email Address"
        placeholder="info@example.com"
        helpText="You'll need this to activate<br>your account and log in"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"
      />

      <Field
        label="I accept the terms"
        type="checkbox"
        @input="$v.resource.acceptTerms.$touch()"
        v-model="resource.acceptTerms"
        :error="acceptTermsError"
      />

      <Field
        label="Send me tips & tricks"
        type="checkbox"
        @input="$v.resource.acceptPromo.$touch()"
        v-model="resource.acceptPromo"
      />

      <div class="form-actions">
        <Btn isBlock :isDisabled="$v.$invalid" primary>Sign Up</Btn>
        <router-link :to="{name: 'login'}">Already have an account?</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import form from '@/mixins/form'
import notification from '@/mixins/notification'
import celebrityNames from '@/mixins/celebrityNames'

import {errorMessages} from '@/lib/error_messages'
import {email, required, sameAs} from 'vuelidate/lib/validators'

import Btn from '@/components/Btn'

export default {
  name: 'RegisterForm',

  mixins: [form, notification, celebrityNames],

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'name',
      'email',
      'companyName',
      'acceptTerms'
    ])
  },

  validations: {
    resource: {
      name: {required},
      email: {email, required},
      companyName: {required},
      acceptTerms: {sameAs: sameAs(() => true)}
    }
  },

  methods: {
    submit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.register-form
  margin: auto
  @extend %card
  position: relative
  overflow: hidden
  padding: $gap-x-large
  border-radius: 5px
  max-width: 95%
  width: 100%

  @include media($media-gt-small)
    width: 450px

  h1
    margin-top: 0
    margin-bottom: $gap-large

  input
    width: 100%

  .form-actions
    text-align: center

    a
      text-transform: uppercase
      font-size: 9px
      display: inline-block
      margin: $gap-medium $gap-small 0

    .btn
      display: block
      margin: 0 auto $gap-small
</style>
